import { Search } from '@/DTOS/Report/Search';
import request from '../../utils/request';

const ReportContractFinancialService = {
    collectionContractFinancial: (search: Search) => {
        return request('/report/collectionContractFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    paymentContractFinancial: (search: Search) => {
        return request('/report/paymentContractFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },

    balanceContractFinancial: (search: Search) => {
        return request('/report/balanceContractFinancial', {
            method: 'POST',
            body: JSON.stringify({ request: { ...search } }),
        });
    },
};

export default ReportContractFinancialService;
